import { render, staticRenderFns } from "./AdminUsersComponent.vue?vue&type=template&id=65836e1d&scoped=true"
import script from "./AdminUsersComponent.vue?vue&type=script&lang=js"
export * from "./AdminUsersComponent.vue?vue&type=script&lang=js"
import style0 from "./AdminUsersComponent.vue?vue&type=style&index=0&id=65836e1d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65836e1d",
  null
  
)

export default component.exports